var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',_vm._g({staticClass:"modal_video"},_vm.$listeners),[_c('BaseVideo',_vm._b({ref:"video",on:{"ended":_vm.onVideoEnded}},'BaseVideo',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }